import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.748.14a2.595 2.595 0 0 0-1.68 0l-2.913.994A1.728 1.728 0 0 0 0 2.776v9.116c0 1.286 1.322 2.123 2.445 1.548l1.923-.985c.34-.174.74-.174 1.08 0l2.457 1.258a2.6 2.6 0 0 0 2.374 0l2.787-1.427c.572-.293.934-.893.934-1.548V2.007C14 .826 12.87-.01 11.776.365l-2.302.786a1.18 1.18 0 0 1-.764 0L5.748.14ZM4.184 1.664l-2.57.878a.247.247 0 0 0-.166.234v9.116c0 .183.19.303.35.22l1.923-.984c.15-.077.304-.138.463-.184v-9.28Zm1.448 9.28c.158.046.314.107.463.184l2.272 1.163V2.595a2.616 2.616 0 0 1-.115-.037l-2.62-.894v9.28Zm4.183-8.349v9.697l2.603-1.333a.248.248 0 0 0 .134-.221V2.007a.242.242 0 0 0-.318-.235l-2.302.786a2.606 2.606 0 0 1-.117.037Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }